<template>
  <section class="section">
    <div class="container">
      <div class="row">
        <h3 class="text-center center-block">Liquidaciones a empresas clientes</h3>
        <div class="pull-right" style="padding-bottom: 1em;">
          <router-link to="/liquidaciones/clientes/form/new" class="btn btn-fill">Nueva liquidación</router-link>
        </div>
      </div>
      <div class="row">
        <div class="box-style line-top smart-form">
          <div class="panel panel-default">
            <div class="panel-head"></div>
            <div class="panel-body">
              <div class="col-xs-12 col-sm-1">
                <div class="form-group">
                  <label for="">Número</label>
                  <input type="text" v-model="filtros.numero" class="form-control">
                </div>
              </div>
              <div class="col-xs-12 col-sm-3">
                <div class="form-group">
                  <label for="">Empresa</label>
                  <combo-sucursales v-model="filtros.empresa"></combo-sucursales>
                </div>
              </div>
              <div class="col-xs-12 col-sm-2">
                <div class="form-group">
                  <label for="">Estado</label>
                  <select v-model="filtros.estado" class="form-control">
                    <option value>Todos</option>
                    <option value="Generado">Generado</option>
                    <option value="Cerrado">Cerrado</option>
                    <option value="Parcial">Cobrado parcialmente</option>
                    <option value="Cobrado">Cobrado totalmente</option>
                  </select>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6">
                <div class="col-xs-6">
                  <div class="form-group">
                    <label for="">Desde</label>
                    <date-picker v-model="filtros.desde" :default-date="filtros.desde"></date-picker>
                  </div>
                </div>
                <div class="col-xs-6">
                  <div class="form-group">
                    <label for="">Hasta</label>
                    <date-picker v-model="filtros.hasta" :default-date="filtros.hasta"></date-picker>
                  </div>
                </div>
              </div>
            </div>
            <div class="panel-footer text-center">
                <div class="form-group form-action">
                  <button type="button" @click="getLiquidaciones()" class="btn btn-fill btn-primary">Aplicar</button>
                </div>
            </div>
          </div>
          
          <table class="table table-no-first-pad table-liquid">
            <thead>
              <tr>
                <th></th>
                <th>Número</th>
                <th>Fecha de creación</th>
                <th>Empresa</th>
                <th>Monto</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="liquidacion in liquidacionesFiltradas" :key="liquidacion._id">
                <td></td>
                <td>{{liquidacion.numero}}</td>
                <td>{{liquidacion.fechaCreacion | formatFecha}}</td>
                <td>{{liquidacion.empresa.empresa.razonSocial}}-{{liquidacion.empresa.denominacion}}</td>
                <td style="text-align: right;">{{liquidacion.montoTotal | formatMoneda}}</td>
                <td :class="liquidacion.estado | lower"><b>{{liquidacion.estado}}</b></td>
                <td>
                  <ul class="table-actions smart-form">
                    <!--
                    <li v-if="liquidacion.estado === 'Generado'">
                      <a class="btn btn-xs btn-ghost js-editar" type="button">
                        <i class="fa fa-actions fa-pencil"></i>
                      </a>
                    </li>
                    -->
                    <li v-if="liquidacion.estado === 'Generado'">
                      <a  @click.prevent="clickCerrar(liquidacion)" class="btn btn-xs btn-ghost" type="button">
                        <i class="fa fa-actions fa-calculator"></i>
                      </a>
                    </li>
                    <li v-if="liquidacion.estado === 'Cerrado' || liquidacion.estado === 'Parcial' || liquidacion.estado === 'Cobrado'">
                      <router-link :to="'/liquidaciones/clientes/cobro/' + liquidacion._id" class="btn btn-xs btn-ghost" type="button">
                        <i class="fa fa-actions fa-money"></i>
                      </router-link>
                    </li>
                    <li>
                      <router-link class="btn btn-xs btn-ghost" :to="'/liquidaciones/clientes/detalle/' + liquidacion._id" type="button">
                        <i class="fa fa-actions fa-eye"></i>
                      </router-link>
                    </li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="modal" v-if="liquidacionActiva" ref="modalPago" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title">Crear pago</h4>
          </div>
            <div class="modal-body">
              <div class="smart-form">
                <div class="form-group">
                  <label for="">Monto</label>
                  <input type="text" class="form-control">
                  <span class="label label-info">El pago se imputará a la liquidación {{liquidacionActiva.numero}}</span>
                </div>
                <div class="form-group">
                  <label for="">Tipo de pago</label>
                  <select name="" id="" class="form-control">
                    <option value=""></option>
                  </select>
                </div>
                <div class="form-group">
                  <label for="">Comprobante</label>
                  <input type="text" class="form-control">
                </div>
                <div class="form-group">
                  <div class="col-xs-6">
                    <label for="">Movimientos en la liquidación ({{liquidacionActiva.movimientos.length}})</label>
                  </div>
                  <div class="col-xs-6">
                    <!--
                    <label for="" class="text-right">Saldo: {{liquidacionActiva.saldo | formatMoneda}}</label>
                    -->
                  </div>
                  <table class="table">
                    <thead>
                      <tr>
                        <th>Fecha</th>
                        <th>Tipo</th>
                        <th>Monto a pagar</th>
                        <th>Monto pagado</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="movimiento in liquidacionActiva.movimientos" :key="movimiento._id">
                        <td>{{movimiento.fecha | formatFecha}}</td>
                        <td>{{movimiento.tipo}}</td>
                        <td>
                          <span v-if="!movimiento.esPago">{{movimiento.importe | formatMoneda}}</span>
                        </td>
                        <td>
                          <span v-if="movimiento.esPago">{{movimiento.importe | formatMoneda}}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!--
                    <span class="label label-danger">{{liquidacionActiva.saldo}}</span>
                  -->
                </div>
                <div class="form-group">
                  <div class="text-center center-block">
                    <button class="btn btn-fill">Guardar</button>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  import $ from 'jquery'
  import DatePicker from '../Shared/DatePicker'
  import ComboSucursales from '../Shared/ComboEmpresasCliente'
  import moment from 'moment'
  import 'sweetalert2/dist/sweetalert2.css'
  import swal from 'sweetalert2'
  // import {sortBy} from 'lodash'
  export default {
    components: {
      'date-picker': DatePicker,
      'combo-sucursales': ComboSucursales
    },
    filters: {
      formatFecha (value) {
        return moment(new Date(value)).format('DD/MM/YYYY HH:mm')
      },
      formatMoneda (value) {
        return '$ ' + parseFloat(value).toFixed(2)
      },
      lower (value) {
        return `status-${value.trim().toLowerCase()}`
      }
    },
    computed: {
      liquidacionesFiltradas () {
        const me = this
        let liquidaciones = me.liquidaciones
        if (me.filtros.numero.trim() !== '') {
          liquidaciones = liquidaciones.filter((liquidacion) => {
            return liquidacion.numero.toString().includes(me.filtros.numero.trim())
          })
        }
        if (me.filtros.empresa !== '-1') {
          liquidaciones = liquidaciones.filter((liquidacion) => {
            return liquidacion.empresa._id === me.filtros.empresa
          })
        }
        if (me.filtros.desde) {
          liquidaciones = liquidaciones.filter((liquidacion) => {
            return new Date(liquidacion.fechaCreacion) >= me.filtros.desde
          })
        }
        if (me.filtros.estado) {
          liquidaciones = liquidaciones.filter((liquidacion) => {
            return liquidacion.estado === me.filtros.estado
          })
        }
        return liquidaciones
      }
    },
    data () {
      return {
        liquidaciones: [],
        paginacion: {
          currentPage: 1,
          pageSize: 10,
          totalPages: 0
        },
        liquidacionActiva: {
          saldo: 0,
          movimientos: []
        },
        filtros: {
          numero: '',
          empresa: '-1',
          desde: moment().add(-40, 'days').toDate(),
          hasta: new Date(),
          estado: null
        }
      }
    },
    mounted () {
      const me = this
      me.getLiquidaciones()
    },
    methods: {
      getLiquidaciones () {
        const me = this
        if (!me.filtros.desde || !me.filtros.hasta) {
          return
        }
        me.$http.post('/api/admin/liquidaciones/clientes', {
          desde: me.filtros.desde,
          hasta: me.filtros.hasta
        }).then(({body}) => {
          let liquidaciones = body.liquidaciones
          liquidaciones.forEach((liquidacion) => {
            liquidacion.seleccionada = false
          })
          me.liquidaciones = liquidaciones
        }, (err) => {
          console.error(err)
        })
      },
      cerrarLiquidacion (liquidacion) {
        const me = this
        me.$http.post('/api/admin/liquidacionescliente/cerrar', {
          idLiquidacion: liquidacion._id
        }).then(({body}) => {
          me.$emit('mostrar-notificacion', 'El cierre de la liquidación ha generado', 'success')
          liquidacion.estado = 'Cerrado'
        }, (err) => {
          liquidacion.estado = 'Generado'
          console.error(err)
        })
      },
      clickCerrar (liquidacion) {
        const me = this
        swal({
          title: 'Cerrar liquidación',
          text: '¿Desea cerrar la liquidación?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Si, cerrar',
          cancelButtonText: 'No, cerrar esta ventana'
        }).then(() => {
          me.cerrarLiquidacion(liquidacion)
        }, (dismiss) => {
          return false
        })
      },
      crearPago (liquidacion) {
        const me = this
        liquidacion.movimientos = []
        liquidacion.saldo = 0
        me.liquidacionActiva = liquidacion
        me.$http.get('/api/admin/liquidaciones/movimientos', {
          params: {
            id: liquidacion._id
          }
        }).then(({body}) => {
          let saldo = 0
          me.liquidacionActiva.movimientos = body.movimientos
          me.liquidacionActiva.movimientos.forEach((movimiento) => {
            if (!movimiento.esPago) {
              saldo += movimiento.importe
            } else {
              saldo -= movimiento.importe
            }
          })
          me.liquidacionActiva.saldo = saldo
          $(me.$refs.modalPago).modal()
        }, (err) => {
          console.error(err)
        })
      }
    }
  }
</script>
<style scoped>
.status-generado {
  background-color: #fbf7ad;
}
.status-cerrado {
  background-color: #dd6262;
  color: #f0f0f0;
}
.status-cobrado {
  background-color: #99be8f;
  color: #f0f0f0;
}
</style>



// WEBPACK FOOTER //
// ListaClientes.vue?092c80ad